import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboardCompletedPatways = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
			fill: "#F7EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6043 28.3989V29.5115C41.6028 32.1192 40.7584 34.6566 39.197 36.7452C37.6356 38.8338 35.4409 40.3618 32.9401 41.1012C30.4394 41.8406 27.7667 41.7518 25.3205 40.8481C22.8744 39.9443 20.7859 38.2741 19.3666 36.0864C17.9472 33.8988 17.2731 31.311 17.4447 28.7089C17.6163 26.1068 18.6244 23.6299 20.3187 21.6475C22.013 19.6652 24.3027 18.2836 26.8463 17.7089C29.3899 17.1343 32.0512 17.3972 34.4332 18.4585",
			stroke: "#661887",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6046 19.8374L29.5117 31.9424L25.8838 28.3145",
			stroke: "#661887",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDashboardCompletedPatways;
